import React, { useEffect, useState } from "react";

function ClientModal({ isOpen, onClose, onCreate, onUpdate, initial }) {
  const [saving, setSaving] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [form, setForm] = useState({ name: "", contact: "", address: "" });

  useEffect(() => {
    if (initial) setForm({ name: initial.name || "", contact: initial.contact || "", address: initial.address || "" });
    else setForm({ name: "", contact: "", address: "" });
    setFormMessage("");
  }, [initial, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    setFormMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage("");
    if (!form.name || !form.name.trim()) return setFormMessage("Client name is required");
    setSaving(true);
    try {
      if (initial && initial.id) {
        const updated = await onUpdate?.(initial.id, { name: form.name.trim(), contact: form.contact.trim(), address: form.address.trim() });
        setSaving(false);
        onClose(updated || null);
      } else {
        const created = await onCreate?.({ name: form.name.trim(), contact: form.contact.trim(), address: form.address.trim() });
        setSaving(false);
        onClose(created || null);
      }
      setForm({ name: "", contact: "", address: "" });
    } catch (err) {
      setFormMessage(err?.message || "Failed to save client");
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
   <div className="modal-overlay">
  <div className="contacts-form"> {/* ✅ reuse same UI */}

    <div className="modal-header">
      <h3 style={{ margin: 0 }}>
        {initial && initial.id ? "Edit Client" : "Add New Client"}
      </h3>
    </div>

    <form onSubmit={handleSubmit} className="form-body">

      {/* CLIENT NAME */}
      <div className="input-group">
        <input
          type="text"
          placeholder=" "
          name="name"
          value={form.name}
          onChange={handleChange}
        />
        <label>Client Name</label>
      </div>

      {/* CONTACT */}
      <div className="input-group">
        <input
          type="text"
          placeholder=" "
          name="contact"
          value={form.contact}
          onChange={handleChange}
        />
        <label>Contact Number</label>
      </div>

      {/* ADDRESS */}
      <div className="input-group">
        <input
          type="text"
          placeholder=" "
          name="address"
          value={form.address}
          onChange={handleChange}
        />
        <label>Address</label>
      </div>

      {/* ERROR */}
      {formMessage && (
        <div className="form-error">{formMessage}</div>
      )}

      {/* BUTTONS */}
      <div className="form-buttons">
        <button type="submit" className="btn-primary">
          {saving
            ? "Saving…"
            : initial && initial.id
            ? "Save"
            : "Create"}
        </button>

        <button
          type="button"
          className="btn-secondary"
          onClick={() => onClose(null)}
        >
          Cancel
        </button>
      </div>

    </form>
  </div>
</div>
  );
}

export default ClientModal;
